// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorText_error__gvgmc"};